import { useLanguage } from '@/contexts/LanguageContext';
import { SUPPORTED_LANGUAGES, getTranslationsCount } from '@/lib/i18n';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function LanguageDebug() {
  const { language, setLanguage, t } = useLanguage();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background p-4">
      <div className="max-w-4xl mx-auto space-y-6">
        <div className="flex items-center gap-4 mb-6">
          <Button variant="ghost" size="icon" onClick={() => navigate(-1)}>
            <ArrowLeft className="w-5 h-5" />
          </Button>
          <h1 className="text-2xl font-bold">Language Debug</h1>
        </div>
        
        <Card className="p-6 space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <strong className="text-sm text-muted-foreground">Current Language:</strong>
              <div className="text-lg">{language} ({SUPPORTED_LANGUAGES[language]?.name})</div>
            </div>
            
            <div>
              <strong className="text-sm text-muted-foreground">HTML lang attr:</strong>
              <div className="text-lg">{document.documentElement.getAttribute('lang')}</div>
            </div>
            
            <div>
              <strong className="text-sm text-muted-foreground">Navigator language:</strong>
              <div className="text-lg">{navigator.language}</div>
            </div>
            
            <div>
              <strong className="text-sm text-muted-foreground">localStorage:</strong>
              <div className="text-lg">{localStorage.getItem('cashee-language') || 'not set'}</div>
            </div>
            
            <div className="col-span-2">
              <strong className="text-sm text-muted-foreground">Translations loaded:</strong>
              <div className="text-lg">{getTranslationsCount(language)} keys</div>
            </div>
          </div>
        </Card>
        
        <Card className="p-6 space-y-4">
          <h2 className="text-lg font-semibold">Test Translations</h2>
          <div className="space-y-2 font-mono text-sm">
            <div className="p-2 bg-muted rounded">
              <span className="text-muted-foreground">settings.title:</span> "{t('settings.title')}"
            </div>
            <div className="p-2 bg-muted rounded">
              <span className="text-muted-foreground">settings.language:</span> "{t('settings.language')}"
            </div>
            <div className="p-2 bg-muted rounded">
              <span className="text-muted-foreground">toast.saved:</span> "{t('toast.saved')}"
            </div>
            <div className="p-2 bg-muted rounded">
              <span className="text-muted-foreground">toast.languageChanged:</span> "{t('toast.languageChanged')}"
            </div>
          </div>
        </Card>
        
        <Card className="p-6 space-y-4">
          <h2 className="text-lg font-semibold">Switch Language</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
            {Object.entries(SUPPORTED_LANGUAGES).map(([code, { name, flag }]) => (
              <Button
                key={code}
                onClick={() => setLanguage(code as any)}
                variant={code === language ? "default" : "outline"}
                className="w-full"
              >
                {flag} {code}
              </Button>
            ))}
          </div>
        </Card>
      </div>
    </div>
  );
}
